// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"ai-estimated-label_tooltip__n2WAe"};